import { Col, Row } from "react-bootstrap";

import { useIsMemberCovered } from "../../hooks/useIsMemberCovered";
import { useIsValidProvider } from "../../hooks/useIsValidProvider";

export const PretreatmentEstimate = () => {
    const isMemberCovered = useIsMemberCovered("dental");
    const isValidProvider = useIsValidProvider("D");

    if (isMemberCovered || isValidProvider) {
        return (
            <>
                <Row className="my-2">
                    <Col>
                        <h5 className="pretreatment-msg form-label">
                            We suggest a pretreatment estimate on any dental service over $250
                        </h5>
                    </Col>
                </Row>
            </>
        );
    }
    return null;
};
